import { addAccState } from './store';
import i18n from '../../../../i18n';
import { addAccountBarPadBottom } from './safeAreaBar';

const Success = () => {
  return (
    <div>
      {/* ── 中心内容（y≈224，距顶部约 140px 留给 navbar 下方） ── */}
      <div class="flex flex-column align-center" style={{ padding: '0 16px', 'margin-top': '140px', gap: '20px' }}>
        {/* 成功圆形图标 */}
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1916_4905)">
            <path
              d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
              fill="#46DD93"
            />
            <path
              d="M24.0851 41.2626C24.4844 41.7021 25.0413 41.9659 25.6343 41.9965C26.2273 42.0272 26.8083 41.8221 27.2508 41.4261L27.3543 41.3286L42.8538 25.5786C43.2633 25.1625 43.4951 24.6034 43.5 24.0196C43.505 23.4357 43.2828 22.8728 42.8804 22.4498C42.4779 22.0267 41.9269 21.7767 41.3435 21.7524C40.7601 21.7282 40.1902 21.9317 39.7541 22.3199L39.6468 22.4219L25.8153 36.4761L19.6653 29.7059C19.2807 29.2824 18.7492 29.0214 18.179 28.9758C17.6087 28.9303 17.0425 29.1036 16.5956 29.4606L16.4876 29.5529C16.0639 29.9375 15.8027 30.4692 15.7571 31.0396C15.7116 31.61 15.8851 32.1764 16.2423 32.6234L16.3346 32.7314L24.0851 41.2626Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1916_4905">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>

        {/* 文字 */}
        <div class="flex flex-column align-center" style={{ gap: '8px', 'align-self': 'stretch' }}>
          <span
            class="color-D"
            style={{
              'font-size': '20px',
              'font-weight': '900',
              'line-height': '1.25',
              'text-align': 'center',
              'align-self': 'stretch',
            }}
          >
            {i18n.AddAccount.SuccessTitle}
          </span>
          <span
            class="font-s-S"
            style={{
              color: 'var(--text-2)',
              'line-height': '1.4',
              'text-align': 'center',
              'max-width': '299px',
            }}
          >
            {i18n.AddAccount.SuccessDesc}
          </span>
        </div>
      </div>

      {/* ── 完成按钮（固定在底部） ── */}
      <div
        class="fixed position-b position-l width-100 bg-c"
        style={{
          'padding-top': '16px',
          'padding-left': '16px',
          'padding-right': '16px',
          'padding-bottom': `${addAccountBarPadBottom(16)}px`,
          'z-index': 150,
        }}
      >
        <button
          class="confirm-btn btn-rounded"
          style={{
            width: '100%',
          }}
          onclick={() => {
            addAccState.riskResumeFromList = false;
            addAccState.step = 1;
          }}
        >
          {i18n.OpenProgress.Common.Done}
        </button>
      </div>
    </div>
  );
};

export default Success;
